import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, setDoc, doc, updateDoc } from 'firebase/firestore';

function DatasPorCategoria({ modo, categorias }) {
  const [dados, setDados] = useState([]);

  useEffect(() => {
    setDados(categorias);
  }, [categorias]);

  function atualizarCampo(index, campo, valor) {
    const novo = [...dados];
    novo[index][campo] = valor;
    setDados(novo);
  }

  async function atualizarDiasDeSnapshot(inicio, fim) {
    const datasExistentes = new Set();

    // Lê todas as datas já salvas em diasDeSnapshot
    const snapshot = await getDocs(collection(db, 'diasDeSnapshot'));
    snapshot.forEach(doc => datasExistentes.add(doc.id)); // Ex: '2025-07-15'

    // Calcula as datas de execução (um dia após o fim de cada semana)
    const inicioDate = new Date(inicio);
    const fimDate = new Date(fim);

    const datasParaAdicionar = [];
    let cursor = new Date(inicioDate);

    while (cursor <= fimDate) {
      const fimDaSemana = new Date(cursor);
      fimDaSemana.setDate(fimDaSemana.getDate() + 6);
      if (fimDaSemana > fimDate) fimDaSemana.setTime(fimDate.getTime());

      const execucao = new Date(fimDaSemana);
      execucao.setDate(execucao.getDate() + 1); // +1 dia

      const idData = execucao.toISOString().slice(0, 10); // formato 'YYYY-MM-DD'

      if (!datasExistentes.has(idData)) {
        datasParaAdicionar.push({ id: idData, dataVerificada: 'pendente' });
      }

      cursor.setDate(cursor.getDate() + 7);
    }

    // Salva as novas datas no Firestore
    for (const data of datasParaAdicionar) {
      await setDoc(doc(db, 'diasDeSnapshot', data.id), {
        dataVerificada: data.dataVerificada
      });
      console.log(`📅 Adicionada data de execução: ${data.id}`);
    }
  }

  async function atualizarDatas(catId, inicio, fim) {
    try {
      const ref = doc(db, `modos/${modo}/categorias/${catId}`);
      await updateDoc(ref, { inicio, fim });

      // Novo: gera as datas de snapshot globais
      const SNAPSHOTS_ATIVOS = false; // <- muda para true quando quiseres reativar

      if (SNAPSHOTS_ATIVOS) {
        await atualizarDiasDeSnapshot(inicio, fim);
      }

      alert(`Datas atualizadas para ${catId}`);
    } catch (erro) {
      console.error('Erro ao atualizar datas:', erro);
    }
  }

  return (
    <div className="admin-datas-categorias-bloco">
      <h2>Datas por Categoria – {modo}</h2>
      {dados.map((cat, index) => (
        <div key={cat.id} className="admin-categoria-linha">
          <strong>{cat.id}</strong>
          <div className="datas">
            <label>
              Início
              <input
                type="date"
                value={cat.inicio || ''}
                onChange={(e) => atualizarCampo(index, 'inicio', e.target.value)}
              />
            </label>
            <label>
              Fim
              <input
                type="date"
                value={cat.fim || ''}
                onChange={(e) => atualizarCampo(index, 'fim', e.target.value)}
              />
            </label>
            <button onClick={() => atualizarDatas(cat.id, cat.inicio, cat.fim)}>
              Guardar
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DatasPorCategoria;
